// LoadingScreen — порт `_Component9` из bundle (line 18803).
// «TWAP DETECT» с золотыми линиями + анимированный bar внизу.
// Используется при splash (initial load) и embedded (внутри dashboard).

import { useEffect } from "react";

interface Props {
  minDurationMs?: number;
  onDone?: () => void;
  /** embedded — показывается внутри другого контента (не fullscreen). */
  embedded?: boolean;
}

export function LoadingScreen({
  minDurationMs = 0,
  onDone,
  embedded = false,
}: Props) {
  useEffect(() => {
    if (!onDone || minDurationMs <= 0) return;
    const t = window.setTimeout(onDone, minDurationMs);
    return () => window.clearTimeout(t);
  }, [minDurationMs, onDone]);

  return (
    <div
      className={`brand-loading-root${embedded ? " brand-loading-root--embedded" : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Загрузка TWAP Detect"
    >
      <div className="brand-loading-inner">
        <div className="brand-loading-twap">TWAP</div>
        <div className="brand-loading-detect-row">
          <span className="brand-loading-line" aria-hidden />
          <span className="brand-loading-detect">DETECT</span>
          <span className="brand-loading-line" aria-hidden />
        </div>
        <div className="brand-loading-bar" aria-hidden>
          <span />
        </div>
      </div>
    </div>
  );
}
